export const getProjectFromProjectData = (projectData) => {
  try {
    const { id, name, address, description, status } = projectData;

    const project = {
      id,
      name,
      address,
      status,
      description,
      customer: projectData.endCustomer,
      partner: projectData.partners,
      created: projectData.createdAt,
    };

    return project;
  } catch (err) {
    return null;
  }
};

export const getTestFromTestData = (testData) => {
  try {
    const {
      testid,
      testname,
      testtype,
      projectid,
      goal,
      overview,
      airsamplerrate,
      surfacesamplerrate,
      testexecuted,
      testordernumber,
    } = testData;

    const testObj = {
      id: testid,
      projectId: projectid,
      name: testname,
      type: testtype,
      goal,
      overview,
      airSamplerRate: airsamplerrate,
      surfaceSampleArea: surfacesamplerrate,
      isCompleted: testexecuted,
      testordernumber,
    };

    return testObj;
  } catch (err) {
    return null;
  }
};

export const getSegmentFromSegmentsData = (segmentData) => {
  try {
    const {
      comments,
      floorplan,
      intervalcount: intervalCount,
      intervalduration: intervalDuration,
      op: opCount,
      platekind: plateKind,
      projectid: projectId,
      segmentid: id,
      segmentname: name,
      segmentstested: segmentsTested,
      sp: spCount,
      surveydate: surveyDate,
      testid: testId,
      sprayername: sprayerType,
      testmetadata,
    } = segmentData;

    const displayIntervalDuration =
      intervalDuration === 'custom_ver' ? 5 : intervalDuration;

    const segment = {
      comments,
      floorplan,
      intervalCount,
      intervalDuration: displayIntervalDuration,
      opCount,
      plateKind,
      projectId,
      id,
      name,
      segmentsTested,
      spCount,
      surveyDate,
      testId,
      sprayerType,
      testmetadata: testmetadata[id],
    };

    return segment;
  } catch (err) {
    return null;
  }
};

export const getScenarioFromScenarioData = (scenarioData, testId) => {
  try {
    const {
      scenariodescription: description,
      scenarioid: id,
      scenarioname: name,
      segmentid,
    } = scenarioData;

    const scenario = {
      testId,
      description,
      id,
      name,
      segmentid,
    };

    return scenario;
  } catch (err) {
    return null;
  }
};

export const getSamplePointsFromSPData = (samplePointsData, testId) => {
  try {
    const {
      airSamplerRate,
      airsamplernodeid: airSamplerNodeId,
      collectionmethod: collectionMethod,
      floorplan,
      segmentid: segmentId,
      spcoordx: x,
      spcoordy: y,
      spid: id,
      spname: name,
      spnumber: number,
      surfaceSampleRate: surfaceSamplerRate,
    } = samplePointsData;

    const samplePoint = {
      testId,
      airSamplerRate,
      airSamplerNodeId,
      collectionMethod,
      floorplan,
      segmentId,
      x,
      y,
      id,
      name,
      number,
      surfaceSamplerRate,
    };

    return samplePoint;
  } catch (err) {
    return null;
  }
};

export const getSampleFromSampleData = (sampleData, testId) => {
  try {
    const {
      timeInterval,
      endtime: endTime,
      sampleid: id,
      samplename: name,
      sampletype: type,
      samplerate: rate,
      samplenumber: number,
      scenarioid: scenarioId,
      spcoordx: x,
      spcoordy: y,
      spid: spId,
      spname: spName,
      spnumber: spNumber,
      starttime: startTime,
    } = sampleData;

    const sample = {
      testId,
      endTime,
      id,
      name,
      type,
      rate,
      number,
      scenarioId,
      x,
      y,
      spId,
      spName,
      spNumber,
      startTime,
      timeInterval,
    };

    return sample;
  } catch (err) {
    return null;
  }
};

export const getOriginPointFromOPData = (opData, testId) => {
  const { tagLotNumber } = opData;

  const tagLots = tagLotNumber || [];

  const tags = opData.tags.map(({ tag, scenarioId }) => {
    const tagLot = tagLots.filter((t) => t.tag === tag);

    return {
      tag,
      scenarioId,
      lotNumber: tagLot[0]?.lotNumber || null,
      expirationDate: tagLot[0]?.expirationDate || null,
    };
  });

  const opObj = {
    testId,
    floorplan: opData.floorplan,
    x: opData.opcoordx,
    y: opData.opcoordy,
    id: opData.opid,
    name: opData.opname,
    number: opData.opnumber,
    segmentId: opData.segmentid,
    sprayNodeId: opData.spraynodeid,
    tags: tags,
  };

  return opObj;
};
